import { useContext } from "react";
import { AppContext } from "../context/AppContext";

export const useDebug = () => {
    const { state } = useContext(AppContext);
    return { debug: state.debug };
};
